/* @flow */
import _ from 'lodash';
import moment from 'moment';
import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import FilesTablePreviewDialog from './FilesTablePreviewDialog';
import EventTracking from 'lib/EventTracking';

import './styles/FilesTable.scss';

type Props = {
  files: *,
  filesEventFields: Function,
};

type State = {
  fileModalShown: boolean,
  // TODO: make this flow type better because `Object` is pretty much the same as `any`
  file: Object,
};

class FilesTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { fileModalShown: false, file: {} };
  }

  componentDidMount() {
    EventTracking.trackKey('files.file_list.view');
  }

  showFileModal = (file: Object) => {
    EventTracking.trackKey('files.file_list.item.click', {
      ...this.props.filesEventFields(file),
    });

    this.setState({ fileModalShown: true, file });
  };

  hideFileModal = () => {
    this.setState({ fileModalShown: false, file: {} });
  };

  render() {
    const { file, fileModalShown } = this.state;
    const { files, filesEventFields } = this.props;

    const filesByMonth = _.groupBy(files, item => {
      return item.fileGetMonth;
    });

    return (
      <div className="FilesTable">
        {fileModalShown && (
          <FilesTablePreviewDialog
            onRequestHide={this.hideFileModal}
            file={file}
            filesEventFields={filesEventFields}
          />
        )}

        {Object.keys(filesByMonth).map(month => (
          <Row key={month}>
            <Heading level="3" className="FilesTable-listTitle" data-test="monthHeader">
              {month}
            </Heading>
            <ol className="FilesTable-list">
              {filesByMonth[month].map(item => (
                <li
                  data-test="FilesTable-list-item"
                  className="FilesTable-list-item"
                  key={item.fileCreatedAt + item.fileKey}>
                  <Text color="graphite" element="div" size="xxxsmall" weight="semibold" truncate>
                    <MediaObject figure="right">
                      <div
                        className="FilesTable-list-item-mediaObject"
                        onClick={() => this.showFileModal(item)}>
                        <MediaObject gutter="small">
                          <Image
                            src={item.filePreviewUrl}
                            cover
                            className="FilesTable-list-item-preview"
                          />
                          <Text align="left" element="div">
                            <Text color="chalkboard" element="div" size="xsmall" truncate>
                              {item.fileName}
                            </Text>
                            <Text truncate weight="normal">
                              {item.fileNote}
                            </Text>
                          </Text>
                        </MediaObject>
                      </div>
                      <div>
                        <Text
                          className="FilesTable-list-item-date"
                          size="xxxsmall"
                          truncate
                          weight="normal">
                          {moment(item.fileCreatedAt).format('MM/DD/YY')}
                        </Text>
                        <Button
                          size="xsmall"
                          className="FilesTable-list-item-button"
                          onClick={() => this.showFileModal(item)}>
                          View
                        </Button>
                      </div>
                    </MediaObject>
                  </Text>
                </li>
              ))}
            </ol>
          </Row>
        ))}
      </div>
    );
  }
}

export default FilesTable;
